module.exports = __webpack_public_path__ + "img/ChanChaoLogo.e54da3cb.png";